import { render } from "./ConeBarrier.vue?vue&type=template&id=051a9116"
import script from "./ConeBarrier.vue?vue&type=script&lang=js"
export * from "./ConeBarrier.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__